import { Authenticator, Button, Heading, Text, useAuthenticator, useTheme, View } from '@aws-amplify/ui-react';
import LogoSmall from '../assets/logo-small.svg?react';
import { strings, translate } from '../components/internationalization';

export const components = {
    Header() {
        const { tokens } = useTheme();
        return (
            <View
                padding={tokens.space.large}
                data-amplify-header
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center', // Center all content horizontally
                    textAlign: 'center', // Ensure text aligns centrally
                }}
            >
                <LogoSmall id='logo' />

                <Heading
                    level={4}
                    fontWeight={tokens.fontWeights.semibold}
                    paddingTop={tokens.space.medium}
                >
                    {translate('Instant answers from your documents')}
                </Heading>
            </View>
        );
    },


    Footer() {
        const { tokens } = useTheme();
        return <View textAlign='center' padding={tokens.space.large} data-amplify-footer>
            <Text color={tokens.colors.neutral[80]}>  &copy; {translate(strings.LOGIN_RIGHTS_RESERVED)}</Text>
        </View>
    },

    SignIn: { //
        Footer() {
            const { tokens } = useTheme();
            const { toForgotPassword } = useAuthenticator();

            return (
                <View textAlign='left' paddingLeft={tokens.space.large}>
                    <Button onClick={() => window.location.replace('/')} size='small' variation='link'>
                        {translate("Back")}
                    </Button>
                    <Button onClick={toForgotPassword} size="small" variation="link"  >
                        {translate(strings.LOGIN_FORGOT_PASSWORD)}
                    </Button>
                </View>
            );
        },
    },

    SignUp: { //
        usernameAlias: "email",
        Footer() {
            return <View textAlign='left'>
                <Button onClick={() => window.location.replace('/')} size='small' variation='link'>
                    {translate("Back")}
                </Button>
            </View>
        },
        FormFields() {
            return <div>
                {/* Re-use default `Authenticator.SignUp.FormFields` */}
                <Authenticator.SignUp.FormFields />
                <a href='https://documate.ai/tos' target='blank'>{translate('I accept the terms and conditions through my use of this service.')}</a>
            </div>
        },
    },
    ConfirmSignUp: {//
        Header() {
            const { tokens } = useTheme();
            return <Heading padding={`${tokens.space.xl} 0 0 0`} level={3} textAlign={'center'}>
                {translate(strings.LOGIN_CONFIRMATION_CODE)}
            </Heading>
        },
    },
    SetupTOTP: { //
        Header() {
            const { tokens } = useTheme();
            return <Heading padding={`${tokens.space.xl} 0 0 0`} level={3} textAlign={'center'}>
                Enter Information:
            </Heading>
        },
    },
    ConfirmSignIn: {//
        Header() {
            const { tokens } = useTheme();
            return <Heading padding={`${tokens.space.xl} 0 0 0`} level={3} textAlign={'center'}>
                Enter Information:
            </Heading>
        },
    },
    ForgotPassword: { //
        Header() {
            const { tokens } = useTheme();
            return <Heading padding={`${tokens.space.xl} 0 0 0`} level={3} textAlign={'center'}>
                {translate(strings.LOGIN_RESET_PASSWORD_HEADING)}
            </Heading>
        },
    },
    ConfirmResetPassword: { //
        Header() {
            const { tokens } = useTheme();
            return <Heading padding={`${tokens.space.xl} 0 0 0`} level={3} textAlign={'center'}>
                {translate(strings.LOGIN_CREATE_NEW_PASSWORD_HEADING)}
            </Heading>
        },
    },
};

//TODO Fields new to v6. Make a call if we need them.
//ConfirmVerifyUser
//VerifyUser
//ForceNewPassword
// SelectMfaType?: Omit<Components, 'FormFields'>;
// SetupEmail?: Omit<Components, 'FormFields'>;